import React from 'react';
import { find } from 'lodash';

// local dependecies
import { wellConnectOptIn as WellConnectOptInView } from 'ui/views/widgets/wellConnectOptIn';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { WellConnectOptIn } from 'ui/containers/WellConnectOptIn';
 *
 * // render
 * <WellConnectOptIn propName='propValue'/>
 */
export class WellConnectOptIn extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            consent: true
        };

        this.handleConsentClick = this.handleConsentClick.bind( this );
        this.handleFormSubmit = this.handleFormSubmit.bind( this );
    }

    /**
     * @desc Handles toggling of consent checkbox
     */
    handleConsentClick() {
        log.debug( 'WellConnectOptIn.handleConsentClick()' );

        this.setState( ( state ) => {
            return {
                consent: ! state.consent
            };
        } );
    }

    /**
     * @desc Handles preparation and submission of opt in data
     */
    handleFormSubmit( { phoneNumber } ) {
        log.debug( 'WellConnectOptIn.handleFormSubmit()' );

        this.props.onFormSubmit( {
            formData: {
                phoneNumber,
                optIn: this.state.consent
            },
            submitAction: find( this.props.actions, { name: 'submit' } )
        } );
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <WellConnectOptInView
                { ...this.props }
                consent={ this.state.consent }
                onConsentClick={ this.handleConsentClick }
                onFormSubmit={ this.handleFormSubmit }
            />
        );
    }
}

// set display name
WellConnectOptIn.displayName = 'WellConnectOptIn';

// set default props
WellConnectOptIn.defaultProps = {};

// prop types
WellConnectOptIn.propTypes = {};
